import { memo, useEffect, useState } from 'react';
import { ThinChip } from 'hakobio-react-ui';
import { getColors } from '../../../utilities';
import { CUSTOM_NODES } from '../../../constants/CUSTOM_NODES';
import { CUSTOM_FUNCTIONS } from '../../../constants/CUSTOM_FUNCTIONS';

interface Props {
  component: any;
}

const GenericTooltip = ({ component }: Props) => {
  const [_schema, setSchema] = useState(null);
  const { primaryColor, primaryColorAlpha } = getColors();

  const getSchemaAsync = async () => {
    setSchema(null);
    const type = component.data.type || 'tubing';
    try {
      let importedValue = null;
      switch (component.type) {
        case 'generic':
        case 'genericonedge':
        case 'genericedge':
          importedValue = await CUSTOM_NODES[type].schema();
          break;
        case 'function':
        case 'functionedge':
          importedValue = await CUSTOM_FUNCTIONS[type].schema();
          break;
      }
      setSchema(importedValue);
    } catch (error) {
      setSchema(null);
    }
  };

  useEffect(() => {
    getSchemaAsync();
  }, []);

  const render = () => {
    if (!_schema) {
      return null;
    }
    return (
      <div className="px-1">
        <div className="border-bottom pb-2 my-2">
          {component.data.customName || CUSTOM_NODES[component.data.type].name}
        </div>
        {component?.data &&
          Object.entries(_schema.properties)
            .filter(([key, parameter]) => key !== 'name')
            .map(([key, parameter]: Array<any>) => {
              if (parameter.type === 'string' || parameter.type === 'number') {
                return (
                  <div key={key} className="f-row f2-start gap-2 mb-2">
                    <div
                      className="capitalize"
                      // style={{ color: "black", width: 100 }}
                    >
                      {parameter.name}
                    </div>
                    <ThinChip
                      style={{ width: 'auto' }}
                      auto
                      fontSize="smallText"
                      color={primaryColor}
                      backgroundColor={primaryColorAlpha}
                      label={
                        parameter.units && component.data[key] !== undefined ? (
                          <span className="capitalize">
                            {component.data[key] + ' ' + parameter.units || 'N/C'}
                          </span>
                        ) : (
                          <span className="capitalize">{component.data[key] || 'N/C'}</span>
                        )
                      }
                    />
                  </div>
                );
              }
            })}
      </div>
    );
  };

  return render();
};

function AreEqual(prevTooltip: any, nextTooltip: any) {
  return (
    JSON.parse(JSON.stringify(prevTooltip.component)) ===
    JSON.parse(JSON.stringify(nextTooltip.component))
  );
}

export default memo(GenericTooltip, AreEqual);
